import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WIZARD_STEP_PATH } from "../../constants/paths";
import { Accordion } from "../../elements/Accordion";
import { ExcludeProducts } from "../../elements/AdvancedSetup/ExcludeProducts";
import MetaWizardFooter from "../../elements/MetaWizard/MetaWizardFooter";
import MetaWizardHeader from "../../elements/MetaWizard/MetaWizardHeader";
import ProductsDashboard from "../../elements/ProductsDashboard/ProductsDashboard";
import WizardHeader from "../../elements/WizardHeader";
import { AdSystemT, WizardStepT } from "../../graphql/generated/graphql";
import { useSetWizardStepEffect } from "./useSetWizardStepEffect";

export const MetaProducts = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard meta products" });
  const navigate = useNavigate();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedMessage, setShowUnsavedMessage] = useState(false);
  const handleUnsavedChanges = useCallback((hasUnsaved: boolean) => {
    setHasUnsavedChanges(hasUnsaved);
    if (!hasUnsaved) {
      setShowUnsavedMessage(false);
    }
  }, []);
  const nextButtonHandler = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedMessage(true);
      return;
    }
    navigate(WIZARD_STEP_PATH.META_TEXT_SELECTION);
  };

  useSetWizardStepEffect({ adSystem: AdSystemT.MetaAdsT, wizardStep: WizardStepT.MetaProductsSelectionT });
  return (
    <div>
      <WizardHeader />
      <MetaWizardHeader activeStep={3} />
      <ProductsDashboard adSystem={AdSystemT.MetaAdsT} isWizard />
      <Accordion header={t("Do you need to exclude some products?")}>
        <ExcludeProducts
          adSystem={AdSystemT.MetaAdsT}
          showDashboard={false}
          isWizard
          onHasUnsavedChanges={handleUnsavedChanges}
        />
      </Accordion>
      <MetaWizardFooter
        nextButtonHandler={nextButtonHandler}
        showBackButton={false}
        validationMessage={showUnsavedMessage ? t("Save changes before continuing") : undefined}
      />
    </div>
  );
};
